goog.provide('el8.ptdata.directMessages');
goog.require('el8.model.base');

el8.ptdata.directMessages = (function() {

    var _class = function(spec) {
        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);
    _class.addDateTime('timeReceived');
    _class.addStringProperty('content');
    _class.addStringProperty('emailType');
    _class.addProperty('attachments');
    _class.addIntProperty('fromUserId');
    _class.addIntProperty('toUserId');
    _class.addStringProperty('fromAddress');
    _class.addStringProperty('toAddress');
    _class.addStringProperty('subject');
    _class.addStringProperty('ccdaContentFileName');

    _class.prototype.asSoyMap = function() {
        var m = {};
        m['id'] = this.getId();
        m['receivedTime'] = el8.service.tz.soyStr(this.getTimeReceived());
        m['content'] = this.getContent();
        m['fromAddress'] = this.getFromAddress();
        m['toAddress'] = this.getToAddress();
        m['subject'] = this.getSubject();
        
        m['attachments'] = this.getAttachments();
        m['ccdaContentFileName'] = this.getCcdaContentFileName();
        return m;
    };

    _class.prototype.getChartFeedDate = function() {
        return this.getTimeReceived();
    };

    _class.prototype.signOff = function(opts) {
        $.el8_ajax({
            url: el8.service.urls.get('signOffDirectMessage', [this.getId(), opts.patientId]),
            type: 'POST',
            data: JSON.stringify({"signOff": true}),
            success: function() {
                if (opts.successCb) { opts.successCb(); }
            },
            error: function() {
                if (opts.errorCb) { opts.errorCb(); }
            }
        });
    };
    
    _class.prototype.deleteItem = function(opts) {
        $.el8_ajax({
            url: el8.service.urls.get('deleteDirectMessage', [this.getId(), opts.patientId]),
            type: 'DELETE',
            data: JSON.stringify({}),
            success: function() {
                if (opts.successCb) { opts.successCb(); }
            },
            error: function() {
                if (opts.errorCb) { opts.errorCb(); }
            }
        });
    };

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); }
    });

    return that;

})();
